<template>
	<c-dialog ref="dialog" width="100vw-300" mode="slide" mask-close @close="dialogFormEditConfirm($refs.productForm, arguments)" @resolve="editHandle">
		<c-form ref="productForm" column="3" vertical unit-width="100%">
			<c-title >父项产品信息</c-title>
			<c-form link-parent>
				<c-form-column>
					<c-form-item label="父项产品">
						<c-select ref="parentSelect" name="parent_product_id" async @search="searchProduct" @change="changeParentProduct"  :clear="false"></c-select>
						<info-card code="PRODUCT" :id="product_id"></info-card>
					</c-form-item>
				</c-form-column>
				<c-form-column>
					<c-form-item label="产品类型" v-if="product_id > 0">
						<c-select name="product_type" :options="productTypeName" disabled></c-select>
					</c-form-item>
					<c-form-item label="单位" v-if="product_id > 0">
						<c-input name="unit" disabled></c-input>
					</c-form-item>
				</c-form-column>
				<c-form-column>
					<c-form-item label="产品来源" v-if="product_id > 0">
						<c-select name="product_source" :options="productSourceName" disabled></c-select>
					</c-form-item>
					<c-form-item label="工艺路线" v-if="product_id > 0">
						<c-input name="route_name" disabled></c-input>
					</c-form-item>
				</c-form-column>
			</c-form>
			<c-title>子项产品信息</c-title>
			<c-form-item :label="false" name="product_list" colspan="3">
				<m-operate border>
					<c-button color="main" v-if="auth('b_material_edit') && this.product_id > 0" v-lock="lock('b_material_edit')" prepend-icon="tf-add" @click="globalDialog('productSelector', {props: {initParam: {product_types:[2, 3]}}}, productSelectorHandle)">添加子项产品</c-button>
				</m-operate>
				<c-table ref="material_table" :data="materialList" border :paging="false" width-resize>
					<c-table-column
						type="drag"
					></c-table-column>
					<c-table-column label="子项产品" width="250" fixed="left">
						<template #default="{data}">
							<c-select name="product_id" async @search="searchProduct" :value-data="data.childrenProduct" @change="changeChildrenProduct($event, data)" v-model="data.product_id" :clear="false"></c-select>
						</template>
					</c-table-column>
					<c-table-column label="单位用量" width="200">
						<template #default="{data}">
							<c-input type="stepper" decimal="6" :range="[0,99999999]" name="unit_count" v-model="data.unit_count"></c-input>
						</template>
					</c-table-column>
					<c-table-column label="投料工序" width="200">
						<template #default="{data}">
							<c-select name="process_id" async @search="searchProcess" :value-data="data.childrenProcess" v-model="data.process_id" :clear="false"></c-select>
						</template>
					</c-table-column>
					<c-table-column label="产品编号" width="150" name="product_code"></c-table-column>
					<c-table-column label="产品名称" width="150" name="product_name"></c-table-column>
					<c-table-column label="产品规格" width="150" name="product_spec"></c-table-column>
					<c-table-column label="单位" width="80" name="unit"></c-table-column>
					<c-table-column label="备注" width="150">
						<template #default="{data}">
							<c-input name="remark" v-model="data.remark"></c-input>
						</template>
					</c-table-column>
					<c-table-column label="库存数量" width="100" name="product_count"></c-table-column>
					<c-table-column type="button" label="操作" width="80">
						<template #default="row">
							<c-table-button v-if="auth('b_material_edit')" v-lock="lock('b_material_edit')" icon="tf-trash" @click="row.remove()">删除</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	import {mapState} from "vuex";

	export default {
		data() {
			return {
				product_id: 0,
				materialList: []
			}
		},
		
		computed: {
			...mapState(['productSourceName', 'productTypeName']),
		},

		methods: {
			/************打开新增、编辑弹窗**************/
			open(data) {
				this.view_id = 0;
				this._editState = !!data;
				this.$refs.productForm.clear();
				this.product_id = 0;
				this.materialList = [];
				if (data) {
					this.product_id = data.parent_product_id;
					this.getDetail();
				}
				this.$refs.dialog.open({
					title: data ? '编辑物料清单' : '创建物料清单'
				});
			},

			/**************父产品变更******************/
			changeParentProduct(data){
				this.product_id = data.value;
				this.getDetail();
			},

			/**************子产品变更******************/
			changeChildrenProduct(selectData,rowData){
				if (!selectData.value){
					rowData.product_id = 0;
					rowData.product_code = '';
					rowData.product_name = '';
					rowData.product_spec = '';
					rowData.unit = '';
					rowData.product_count = '';
				}else if (selectData.value){
					//查询商品详情
					this.request({
						url:'/product/detail',
						data: {
							id: selectData.value
						},
						loading: true,
						success: data => {
							rowData.product_id = data.id;
							rowData.product_code = data.product_code;
							rowData.product_name = data.product_name;
							rowData.product_spec = data.product_spec;
							rowData.unit = data.unit;
							rowData.product_count = data.product_count;
						}
					});
				}
			},

			/*******搜索物料清单详情*******************/
			getDetail() {
				this.request({
					url:'/product/detail',
					data: {
						id: this.product_id
					},
					loading: true,
					success: data => {
						this.$refs.parentSelect.setValueData([{
							name: data.product_code + ' | ' + data.product_name,
							value: data.id
						}]);
						this.$refs.productForm.set(data);
						this.queryProductChildrenList();
					}
				});
			},

			/*******查询组成该商品的物料列表*******************/
			queryProductChildrenList() {
				this.request({
					url:'/product/children/list',
					data: {
						product_id: this.product_id
					},
					loading: true,
					success: data => {
						this.materialList = data.map(item =>{
							return item;
						})
					}
				});
			},

			/*******搜索物料清单单位信息*****************/
			searchProduct(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SELF_PRODUCT',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			/*******搜索投料工序信息*****************/
			searchProcess(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'DICPROCESS_SEARCH',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			/******选择产品响应方法*********/
			productSelectorHandle(data) {
				//判断是否已存在于表格之中，已存在则不允许添加
				for (var i = 0; i < data.length; i++) {
					var newProduct = data[i];
					if (this.product_id == newProduct.id){
						this.$message({
							type:'warn',
							message:'子项商品不能与父项商品相同',
						});
						return;
					}
					// var existObj = this.$refs.material_table.getData().find(function (obj) {
					// 	return obj.product_id == newProduct.id
					// });
					// if (existObj){
					// 	this.$message({
					// 		type:'warn',
					// 		message:'子项商品【'+existObj.product_code+' | '+existObj.product_name+'】已存在，请勿重复添加',
					// 	});
					// 	return;
					// }
				}
				//处理数据
				var tempList = data.map(item => {
					var product = item;
					var childrenProduct = [{
						name: item.product_code +' | ' + item.product_name,
						value: item.id
					}];
					product.product_id = item.id;
					product.childrenProduct = childrenProduct;
					return product;
				});
				tempList.map(item =>{
					this.$refs.material_table.push(item);
				})
			},

			/*******提交编辑数据********************/
			editHandle(stop, next) {
				stop();
				this.$refs.productForm.submit({
					url: '/product/children/edit',
					rule: {
						parent_product_id: '请选择父项商品'
					},
					dataFormatter: data => {
						data.product_id = this.product_id||0;
						data.children_product_list  = this.$refs.material_table.getData();
						return data;
					},
					success: (data, res) => {
						next();
						this.$message({
							message:this._editState ? '编辑物料清单成功' : '创建物料清单成功',
						});
						//刷新页面
						this.$emit('resolve');
					}
				})
			}
		}
	}
</script>
<style lang="stylus" scoped>
</style>